import { forwardRef } from "react";

import { Link, type LinkProps } from "@chakra-ui/react";

type Props = LinkProps & {};

export const NavLink = forwardRef<HTMLAnchorElement, Props>(
  ({ ...rest }, ref) => {
    return (
      <Link _currentPage={{ color: "text/fg_info" }} ref={ref} {...rest} />
    );
  },
);
